import { render, staticRenderFns } from "./GenoSpinner.vue?vue&type=template&id=35ef6e96&lang=pug&"
import script from "./GenoSpinner.vue?vue&type=script&lang=js&"
export * from "./GenoSpinner.vue?vue&type=script&lang=js&"
import style0 from "./GenoSpinner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports